import axios from 'axios';

const getApiBaseUrl = () => {
  // Check if running in browser
  if (typeof window === 'undefined') {
    return '/api';
  }

  // Check for API config from public/api-config.js
  if (window.__API_CONFIG__) {
    const isLocalhost = ['localhost', '127.0.0.1', '0.0.0.0'].includes(window.location.hostname);
    
    // Development mode - use localhost
    if (isLocalhost) {
      return window.__API_CONFIG__.DEV_API_BASE_URL || 'https://api.swytrixtech.com/api';
    }
    
    // Production mode - always use production API URL
    if (window.__API_CONFIG__.API_BASE_URL) {
      return window.__API_CONFIG__.API_BASE_URL;
    }
  }

  // Legacy support for other config methods
  const globalConfig =
    window.__ITWEB_API_BASE_URL__ || window.__APP_API_BASE_URL__;

  if (globalConfig) {
    return globalConfig;
  }

  // Environment variable support (for build-time configuration)
  if (typeof process !== 'undefined' && process.env && process.env.API_BASE_URL) {
    return process.env.API_BASE_URL;
  }

  // Fallback: Check hostname
  const isLocalhost = ['localhost', '127.0.0.1', '0.0.0.0'].includes(window.location.hostname);
  
  if (isLocalhost) {
    // Development - use localhost
    return 'https://api.swytrixtech.com/api';
  }
  
  // Production - use production API URL (hardcoded fallback)
  return 'https://api.swytrixtech.com/api';
};

const apiClient = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 20000,
  headers: {
    Accept: 'application/json',
  },
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const message =
      error.response?.data?.message ||
      error.message ||
      'Something went wrong while submitting the form.';

    return Promise.reject(new Error(message));
  }
);

export const submitContactForm = async (payload) => {
  const response = await apiClient.post('/contact', payload);
  return response.data;
};

export const submitQuickOrder = async (payload) => {
  const response = await apiClient.post('/quick-order', payload);
  return response.data;
};

export const submitNewsletterSubscription = async (payload) => {
  const response = await apiClient.post('/newsletter', payload);
  return response.data;
};

export const submitCareerApplication = async ({ resume, ...rest }) => {
  const formData = new FormData();

  Object.entries(rest).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      formData.append(key, value);
    }
  });

  if (resume) {
    formData.append('resume', resume);
  }

  const response = await apiClient.post('/careers', formData);

  return response.data;
};

export const submitMeetingRequest = async (payload) => {
  const response = await apiClient.post('/meeting', payload);
  return response.data;
};


